<template>
    <form id="onboarding-de" class="wrapper wrapper-tab-2" role="form" method="post">
        <header>
            <span class="headline-xlg">Was ist Ihre Hauptmotivation?</span>
        </header>
        <div class="form-input-radio-button-wrapper">
            <form-input-type-radio-button
                v-for="(item, index) in options"
                :key="index"
                :value="item.label"
                :icon="item.icon"
                @onClick="submit(item.label)"
            ></form-input-type-radio-button>
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                choosenMotivation: null,
                options: [
                    {
                        label: 'Abnehmen',
                        icon: 'onboarding.icon-weight'
                    },
                    {
                        label: 'Blutzucker unter Kontrolle haben',
                        icon: 'onboarding.icon-blood-sugar'
                    },
                    {
                        label: 'Über Ernährung lernen',
                        icon: 'onboarding.icon-nutrition'
                    },
                    {
                        label: 'Unterstützung durch Gleichgesinnte erhalten',
                        icon: 'onboarding.icon-support'
                    },
                    {
                        label: 'Allgemeine Gesundheit verbessern',
                        icon: 'onboarding.icon-health'
                    },
                ],
            }
        },

        methods: {
            submit (motivation) {
                this.choosenMotivation = motivation

                let data = {
                    motivation: motivation
                }

                setTimeout(() => {
                    this.$emit('clicked', data)
                }, 250);
            },

            goBack() {
                this.choosenMotivation = null
            }
        }
    }
</script>